import { Info } from "lucide-react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface PaygFilterToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  tooltipContent?: string;
}

export const PaygFilterToggle = ({
  checked,
  onCheckedChange,
  tooltipContent,
}: PaygFilterToggleProps) => {
  return (
    <div className="flex flex-wrap items-center gap-x-2 gap-y-1 sm:flex-nowrap">
      <Switch
        id="payg-filter-toggle"
        checked={checked}
        onCheckedChange={onCheckedChange}
        aria-label="Include pay-as-you-go subscriptions"
      />
      <div className="flex min-w-0 flex-1 items-center gap-1">
        <Label
          htmlFor="payg-filter-toggle"
          className="min-w-0 cursor-pointer text-sm leading-tight text-muted-foreground"
        >
          <span className="block max-w-full break-words">
            Include Pay-as-you-go
          </span>
        </Label>
        {tooltipContent && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-label="Pay-as-you-go filter info"
                className="p-1 text-muted-foreground hover:text-foreground"
              >
                <Info className="h-3 w-3" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-xs">
              <p className="text-xs">{tooltipContent}</p>
            </TooltipContent>
          </Tooltip>
        )}
      </div>
    </div>
  );
};
